import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps
} from 'components/Icon/Icon'
import { ComponentProps } from 'react'

export const Send = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.0709 2.92905C47.4588 3.31704 47.6266 3.84187 47.574 4.34818C47.5588 4.49541 47.5248 4.64107 47.4723 4.78135L32.9018 46.4113C32.6648 47.0885 32.0384 47.5525 31.3214 47.5817C30.6045 47.611 29.9423 47.1996 29.6509 46.5439L21.591 28.409L3.45601 20.349C2.80032 20.0576 2.38896 19.3954 2.41821 18.6785C2.44746 17.9616 2.91139 17.3351 3.58864 17.0981L45.2189 2.52749C45.3557 2.47629 45.4976 2.4428 45.6411 2.42702C45.747 2.41532 45.8532 2.41338 45.9583 2.42093C46.3637 2.44975 46.7609 2.61913 47.0709 2.92905ZM39.1735 8.35156L8.91114 18.9434L22.5292 24.9959L39.1735 8.35156ZM25.0041 27.4707L41.6483 10.8264L31.0565 41.0888L25.0041 27.4707Z"
        fill={color}
      />
    </svg>
  )
}

export default Send
